import { controls } from "../../controls";

const rp442 = {
  label: "NPA Register",
  pageLabel: "NPA Register",
  starting: true,
  url: "rp442",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "Product Code", star: true, width: "col-sm-2" }),
    ...controls.product({ tab: "filter" }),
    ...controls.showData({ tab: "filter", isRequired: true, data: "product_code_display", name: "product_code_display", width: "col-sm-2", displaytype: 'camelcase' }),

    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2" }),

  ],


  form: [],

  history: {
    perPage: 10,
    reportHeader: "NPA REGISTER",
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "CIN",
        accessor: "CIN",
        width: 100,
        rwidth: 30
      },
      {
        Header: "Account Number",
        accessor: "AcctCode",
        width: 140,
        rwidth: 50
      },
      {
        Header: "Name Of Society",
        accessor: "descn",
        width: 200,
        rwidth: 50
      },
      {
        Header: "Outstanding as on date",
        accessor: "Balance",
        type: "currency",
        width: 120
      },
      {
        Header: "Overdue as on date",
        accessor: "OdAmt",
        type: "currency",
        width: 120
      },
      {
        Header: "OD Date",
        accessor: "ExpDate",
        type: "date",
        width: 100,
        rwidth: 30
      },
      {
        Header: "NPA Date",
        accessor: "NPADate",
        type: "date",
        width: 100,
        rwidth: 30
      },

      {
        Header: "Classification of Thak Zindagi",
        columns: [
          {
            Header: "Overdues Above 1 year but below 3 years",
            accessor: "D1_Class",
            type: "currency",
            width: 100
          },
          {
            Header: "Overdues Above 3 year but below 4 years",
            accessor: "D2_Class",
            type: "currency",
            width: 100
          },
          {
            Header: "Overdues Above 4 year but below 6 years",
            accessor: "D3_Class",
            type: "currency",
            width: 100
          },
          {
            Header: "Overdues Above 6 years",
            accessor: "L_A_Class60",
            type: "currency",
            width: 100
          },
          {
            Header: "Overdues Above 6 years (New)",
            accessor: "New_OD_60",
            type: "currency",
            width: 100
          },
          {
            Header: "Non Mortgage Loan above 6 Year",
            accessor: "No_Mrg_6",
            type: "currency",
            width: 100
          },
        ]
      },

      {
        Header: "Total NPA (Outstanding)",
        accessor: "TOT_NPA",
        type: "currency",
        width: 100,
        rwidth: 35
      },
      {
        Header: "Provisions for Suspecious Loan",
        columns: [
          {
            Header: "Standard (Labh Zindagi)",
            accessor: "JIND",
            type: "currency",
            width: 100
          },
          {
            Header: "Sub-Standard (10% Prov.)",
            accessor: "10_Prov",
            type: "currency",
            width: 100
          },
          {
            Header: "Provisions Above 3 year but below 4 years (20%)",
            accessor: "D1_Prov",
            type: "currency",
            width: 100
          },
          {
            Header: "Provisions Above 4 year but below 6 years (30%)",
            accessor: "D2_Prov",
            type: "currency",
            width: 100
          },
          {
            Header: "Provisions Above 6 years (60%)",
            accessor: "D3_Prov",
            type: "currency",
            width: 100
          },
          {
            Header: "Provisions Above 6 years (100%)",
            accessor: "L_A_Prov60",
            type: "currency",
            width: 100
          },
          {
            Header: "Provisions Non-Mortgage Loan (100%)",
            accessor: "No_Mrg_6_100_prov",
            type: "currency",
            width: 100
          }
        ]
      },

      {
        Header: "Total Provisions",
        accessor: "Total_Prov1",
        type: "currency",
        width: 100
      },
      {
        Header: "Provisions on Labh Zindagi 0.40%",
        accessor: "p40_jind",
        type: "currency",
        width: 100
      },
      {
        Header: "Total Provisions",
        accessor: "Total_Prov2",
        type: "currency",
        width: 100
      }
    ]
  }
};

export default rp442;